export default __webpack_public_path__ + "static/media/x.5cd5e215.svg";